import ColorHash from 'color-hash-ts';
import { Badge } from 'components/ui/badge';
import { useTranslation } from 'react-i18next';

const colorHash = new ColorHash();

const SymptomTag: React.FC<{ symptom: string }> = ({ symptom }) => {
  const { t } = useTranslation();
  return (
    <Badge variant="secondary" key={symptom}>
      {/* The dot colour is derived from the symptom key, so it stays an inline value. */}
      <span aria-hidden className="size-2 shrink-0 rounded-full" style={{ backgroundColor: colorHash.hex(symptom) }} />
      {t(`symptomTracking.survey.symptoms.${symptom}`)}
    </Badge>
  );
};

export default SymptomTag;
